import { render, staticRenderFns } from "./YesNoAlt.vue?vue&type=template&id=5ded1616&scoped=true&"
import script from "./YesNoAlt.vue?vue&type=script&lang=js&"
export * from "./YesNoAlt.vue?vue&type=script&lang=js&"
import style0 from "./YesNoAlt.vue?vue&type=style&index=0&id=5ded1616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ded1616",
  null
  
)

export default component.exports